export const DEFAULT_INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes en ms
export const CHECK_LOCKED_PAGE_INTERVAL = 2 * 1000;
